export default __webpack_public_path__ + "static/media/profile.c30eebfc.svg";